import {ObjectTypeId} from "../../../constants";
import {IRule} from "../../../index";
import {Settings} from "./Settings";
import {TSyncfield} from "../../../constants/Syncfields";

type TCategory = 'user' | 'group' | 'department' | 'manager';
type TSelectionType = 'object' | 'event'

interface IStepParams {
    settings: Settings
}

interface ICategory {
    name: string
    value: TCategory
    objectTypeId: ObjectTypeId
}

interface ISelectionType {
    name: string
    value: TSelectionType
    description: string
}

interface ISelection {
    category: TCategory | TCategory[]
    name: string
    type: TSelectionType
    definition: IRuleDefinition | null
}

type TRuleDefinitionName = 'pick_attribute_and_value' | 'pick_ruleset' | 'pick_departments' | 'event' | 'pick_system_permission';

interface IRuleDefinition {
    name: TRuleDefinitionName
    subDepartments?: boolean
    primaryPosition?: boolean
    rule?: Partial<IRule>
    rules?: Partial<IRule>[]
    syncfieldName?: TSyncfield
}